import {assertAndContinue} from 'Asserts';
import {BulkAssemblyAction, BulkAssemblyActionType} from 'molbio/bulk-assembly/BulkAssemblyActions';
import {integrityCheckBulkAssemblyState} from 'molbio/bulk-assembly/BulkAssemblyIntegrityCheck';
import reduceBulkAssembly, {BulkAssemblyState} from 'molbio/bulk-assembly/reduceBulkAssembly';
import {BenchlingAction} from 'redux-stores/Action';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

export interface AllBulkAssembliesState {
  [assemblyId: string]: BulkAssemblyState | undefined;
}

export default function reduceAllBulkAssemblies(
  state: AllBulkAssembliesState = {},
  action: BenchlingAction
): AllBulkAssembliesState {
  if (action.type === BulkAssemblyActionType.BULK_ASSEMBLY_INITIALIZED) {
    return {
      ...state,
      [action.assemblyId]: {
        procedure: action.procedure,
        asyncState: {status: AsyncStatus.NOT_FETCHED},
        fragmentStatusFilter: null,
        constructStatusFilter: null,
      },
    };
  } else if (Object.keys(BulkAssemblyActionType).includes(action.type)) {
    const assemblyAction = action as BulkAssemblyAction;
    const assembly = state[assemblyAction.assemblyId];
    if (
      !assertAndContinue(
        assembly != null,
        `Expected assembly to be initialized when receiving action ${action.type}. \
We might be accidentally trying to edit a finalized assembly.`
      )
    ) {
      return state;
    }
    const newState = reduceBulkAssembly(assembly!, assemblyAction);
    integrityCheckBulkAssemblyState(newState.procedure);
    return {
      ...state,
      [assemblyAction.assemblyId]: newState,
    };
  }
  return state;
}
